import { CwtApiEntity, CwtCrudContract, CwtModel, CwtProp } from "@cawita/core-front/api";
import { Client } from "../client";
import { CustomFieldSetStep } from "./custom-field-set-step.model";


export enum CustomFieldSetTarget {
    Evaluation = 'evaluation'
}

@CwtModel({ name: 'custom-field-set' })
@CwtCrudContract({ path: 'for-machine/custom-field-set', identifier: 'for-machine' })
@CwtCrudContract({ path: 'for-manager/client/:clientId/custom-field-set', identifier: 'for-manager' })
@CwtCrudContract({ path: 'custom-field-set', identifier: 'for-admin' })
export class CustomFieldSet extends CwtApiEntity {
    @CwtProp() client: Client;
    @CwtProp() target: CustomFieldSetTarget;
    @CwtProp({ ref: CustomFieldSetStep }) steps: CustomFieldSetStep[];
}